import { Component, OnDestroy } from '@angular/core';
import { BaseComponent } from '../../components/base/base.component';

@Component({
  template: ''
})
export class BasePage extends BaseComponent implements OnDestroy {
  constructor() {
    super();
  }

  ngOnDestroy(): void {
    super.ngOnDestroy();
  }
}
